import { Modal } from 'bootstrap';

export function showModal(html, redirect = null, options = {}) {
  const _defaults = Object.assign({
    id: 'modalGenericError',
    autofocusEl: 'input', // null | string | HTMLElement
    autofocusElAfter: null, // null | HTMLElement
    keyboard: true,
    backdrop: true,
    focus: true,
  }, options);
  const settings = { ..._defaults, ...options };
  
  // modal element:
  document.body.insertAdjacentHTML('beforeend', html);
  const modalEl = document.querySelector(`#${settings.id}`);

  let autofocusEl = null;
  const autofocusElAfter = (settings.autofocusElAfter) ? settings.autofocusElAfter : null;
  if (settings.autofocusEl) {
    autofocusEl = (typeof settings.autofocusEl === 'string') ? modalEl.querySelector(settings.autofocusEl) : settings.autofocusEl;
  }

  // modal instance:
  const modal = new Modal(modalEl, {
    keyboard: settings.keyboard,
    backdrop: settings.backdrop,
    focus: settings.focus,
  });
  modal.show();
  modalEl.addEventListener('shown.bs.modal', () => {
    if (autofocusEl) {
      autofocusEl.focus();
    }
  });
  modalEl.addEventListener('hidden.bs.modal', () => {
    modal.dispose();
    modalEl.parentNode.removeChild(modalEl);
    if (autofocusElAfter) {
      autofocusElAfter.focus();
    }
    if (typeof redirect === 'string' && redirect) {
      window.location.href = redirect;
    }
  });
}

// const modalHtml = `<div class="modal fade" id="{{id}}" tabindex="-1">
//   <div class="modal-dialog">
//     <div class="modal-content">
//       <div class="modal-header">
//         <h5 class="modal-title">{{title}}</h5>
//         <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Bezárás"></button>
//       </div>
//       <div class="modal-body">
//         {{description}}
//       </div>
//       <div class="modal-footer">
//         <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Bezárás</button>
//       </div>
//     </div>
//   </div>
// </div>`;

// export function showModal(description, redirect = null, options = {}) {
//   var settings = Object.assign({
//     id: 'modalGenericError',
//     title: 'Hoppá!',
//     keyboard: true,
//     backdrop: true,
//     focus: true,
//   }, options);

//   // modal HTML:
//   const html = modalHtml.replace('{{id}}', settings.id);
//   html = html.replace('{{title}}', settings.title);
//   html = html.replace('{{description}}', description);

//   // modal element:
//   document.body.insertAdjacentHTML('beforeend', html);
//   const modalEl = document.querySelector(`#${settings.id}`);

//   // modal instance:
//   var modal = new bootstrap.Modal(modalEl, {
//     keyboard: settings.keyboard,
//     backdrop: settings.backdrop,
//     focus: settings.focus,
//   });
//   modal.show();
//   modalEl.addEventListener('hidden.bs.modal', function(e) {
//     modal.dispose();
//     modalEl.parentNode.removeChild(modalEl);
//     if (typeof redirect === 'string' && redirect) {
//       window.location.href = redirect;
//     }
//   });
// }
